/**
 * An OPTIONAL e-mail allow-list from a build variable (comma-separated):
 * unset or blank = null = no restriction; set without a single address
 * (only commas/spaces) = [] = nobody (fail-closed); otherwise the trimmed,
 * lower-cased addresses - read like apiKeysAdminEmails.
 */
export function parseOptionalEmailAllowlist(
  raw: string | undefined,
): string[] | null {
  if (raw === undefined || raw.trim() === "") return null;
  return raw
    .split(",")
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);
}
